import { FormHelperText } from '@mui/material';

export const ErrorMessageField = ({ error }: { error: string }) => {
  return (
    <FormHelperText error sx={{ mt: 0.5, ml: 1.75 }}>
      {error}
    </FormHelperText>
  );
};
